import { styled } from '@mui/material';

import emptyImage from './empty.png';

export const ImageWrap = styled('div')({
  width: '15%',
  maxWidth: 414,
  justifyContent: 'center',
  marginTop: 10,
  marginBottom: 10,
});

export const Image = styled('div')({
  paddingTop: '66.42512077%',
  background: `url(${emptyImage}) no-repeat center center`,
  backgroundSize: 'contain',
});
